export default {
  useMyLocation: '08112018-155748-0003',
  autocompletePlaceholder: '08112018-155748-0004',
  autocompleteInputError: '22022019-142905-0021',
  autocompleteInputRequiredError: '28082015-174213-3730'
};
